<template lang="pug">
  .welfare-middle-container
    LoadingPage(v-if="isPreRender || isLoading")

    template(v-if="!isLoading")
      component(
        :is="targetPageName"
        :styleVersion="styleVersion"
        :isHitchCarFare="isHitchCarFare"
      )
</template>

<script>
import { env } from '@hb/NBridge/lib/h5';
import config from '@/const/config';
import { isPreRender } from '../../utils';
import { ParamsUtil } from '../../utils/params';
import { handleWelfareStyleVersion, handleHitchCarFareCheck } from './common/helper';
import SPM from './common/spm';
import LoadingPage from './welfare-center-cpns/loading-page';
import { WELFARE_VERSION, WELFARE_CENTER_PAGE_KEY } from './consts';

export default {
  name: 'Bounty',
  components: {
    LoadingPage,
    WelfareCenter: () => import('./welfare-center'),
    WelfareApp: () => import('./welfare'),
    WelfareAlipay: () => import('./welfare-new'),
  },
  data() {
    return {
      // 是否是预渲染环境
      isPreRender: isPreRender(),
      // 是否是加载中
      isLoading: true,
      // 目标页面组件
      targetPageName: '',
      // 页面样式版本
      styleVersion: '',
      // 是否为福利中心顺风车心智版本
      isHitchCarFare: false,
    };
  },
  provide() {
    return {
      getStyleVersion: () => this.styleVersion,
    };
  },
  watch: {
    '$route.query.needRefresh': {
      handler(val) {
        if (val === '1') {
          // 抹除痕迹
          const query = { ...this.$route.query };
          delete query.needRefresh;
          this.$router.replace({ query });
          window.location.reload();
        }
      },
    },
  },
  created() {
    // 预渲染
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    this.judgeTargetPage();
  },
  methods: {
    // 判断目标页面
    async judgeTargetPage() {
      const [styleResult, hitchResult] = await Promise.all([
        handleWelfareStyleVersion(),
        handleHitchCarFareCheck(),
      ]);
      const { data } = styleResult || {};
      const { styleVersion = '' } = data || {};
      this.styleVersion = styleVersion || WELFARE_VERSION.NEW_TASK_SCENE_V3;
      this.isHitchCarFare = !!(hitchResult && hitchResult.isHitchCarFare);
      this.setTargetPageName(this.styleVersion);
      this.isLoading = false;

      // 启动 SPM
      SPM.startup({
        experimentClassification: styleVersion || '',
      });
    },
    // 设置目标页面名称
    setTargetPageName(styleVersion) {
      // 判断是否是旧版福利中心
      const isOldVersion = styleVersion === WELFARE_VERSION.OLD_TASK_SCENE
        || styleVersion === WELFARE_VERSION.NEW_TASK_SCENE_V2;
      // 获取页面类型
      const pageTab = ParamsUtil.getParam('pageTab');

      // 新版页面
      if (!isOldVersion) {
        this.targetPageName = 'welfare-center';
        return;
      }
      // 旧版 => 卡券商城
      if (pageTab === WELFARE_CENTER_PAGE_KEY.coupon) {
        this.redirectToOldMall();
        return;
      }
      // 旧版 => 支付宝端
      if (env.isAliMP || env.isAliMPMonitor) {
        this.targetPageName = 'welfare-alipay';
        return;
      }
      // 旧版 => 微信
      if (env.isWechatMini || env.isWeixin) {
        this.targetPageName = 'welfare-center';
        return;
      }
      // 旧版 => app端
      if (env.isEasyBikeApp) {
        this.targetPageName = 'welfare-app';
        return;
      }
      // 兜底
      this.targetPageName = 'welfare-center';
    },
    // 重定向到旧版卡券商城
    redirectToOldMall() {
      const originUrl = window.location.href;
      const query = originUrl.split('?')[1];
      const redirectUrl = `https://m.hellobike.com/AppBikeMallH5/${
        config.env !== 'pro' ? `${config.env}/` : ''
      }latest/index.html#/mall?${query}`;
      window.location.replace(redirectUrl);
    },
  },
};
</script>
